import { useSelector } from "react-redux";

export const CollapsableFormRegion = props =>{
    const { className, open, title, children, onToggle, ...other} = props;

    const currentTheme = useSelector(state => state.currentTheme);

    return (
        <div className={`form-region-container ${className}`}>
            <div className="form-region-root">    
                {
                    (title) &&            
                    <div className="header">         
                        <div className={`icon k-icon k-i-${open ? "minus" : "plus"}`} onClick={onToggle}></div>
                        {
                            title && 
                            <div className="title" onClick={onToggle}>{title}</div>
                        }
                    </div>
                }
                <div className="content" style={{display: open ? "flex" : "none"}}>
                {
                    children
                }
                </div>
            </div>
            <style>
                {
                    `
                        .form-region-container
                        {
                        }

                        .form-region-root
                        {
                            display: flex;
                            flex-direction: column;
                            background-color: ${currentTheme.componentBg};
                        }

                        .form-region-root > .header
                        {
                            display: flex;
                            align-items: center;
                            /*margin-bottom: 8px;*/
                        }

                        .form-region-root > .header .k-icon
                        {
                            margin-right: 4px;
                        }

                        .form-region-root > .header .k-icon:hover, .form-region-root > .header .title:hover
                        {
                            cursor: pointer;
                        }

                        .form-region-root > .header .title
                        {
                            color: ${currentTheme.componentText};
                            font-style: italic;
                            font-weight: 500;
                        }

                        .form-region-root > .content
                        {                    
                            margin-top: 8px;        
                            flex-direction: column;                            
                        }
                    `
                }
            </style>
        </div>
    );
};